import router from "@/router";
import { domainName } from "@/config/index.js";
import store from "@/store";
import { arrayComparison } from "@/utils/validate";
router.beforeEach((to, from, next) => {
  // 获取token
  let accessToken;
  if (window.location.search) {
    accessToken = window.location.search
      .split("?")[1]
      .split("&")[0]
      .split("=")[1];
    store.commit("user/setAccessToken", accessToken);
  }
  // 判断是否登录
  if (!accessToken) {
    // 未登录 页面是否需要登录
    if (
      to.matched.length > 0 &&
      !to.matched.some((record) => record.meta.requiresAuth)
    ) {
      next();
    }
    let loginAddr;
    if (domainName == "https://www.mtu.plus") {
      loginAddr =
        "https://www.mtu.plus/local/exam/auth.php?servicename=app&callback=https://www.mtu.plus/exam/#/index";
    } else if (domainName == "https://moodle.chenkf.cn") {
      loginAddr =
        "https://moodle.chenkf.cn/local/exam/auth.php?servicename=exam_system&callback=http://localhost:8080";
    } else if (domainName == "http://xylms.zhftc.com") {
      loginAddr =
        "http://xylms.zhftc.com/local/exam/auth.php?servicename=app&callback=http://xylms.zhftc.com/kaoshi";
    }
    window.location.href = loginAddr;
  } else {
    // 用户已经登录 路由的访问权限：当前角色对应的显示权限
    let availableRoute = router.options.routes[1].children.filter((item) => {
      return arrayComparison(item.meta.roles, store.state.user.roleName);
    });
    const index = availableRoute.findIndex((item) =>
      Object.values(item).includes(to.path)
    );
    // 管理员
    if (store.state.user.roleName.includes("admin")) {
      if (index > -1) {
        next();
      } else {
        next({ path: "/index" });
      }
    }
    // 开考教员
    else if (store.state.user.roleName.includes("openTea")) {
      if (index > -1) {
        next();
      } else {
        next({ path: "/index" });
      }
    }
    // 阅卷教员
    else if (store.state.user.roleName.includes("gradeTea")) {
      if (index > -1) {
        next();
      } else {
        next({ path: "/examMarking" });
      }
    }
    // 学生
    else {
      if (index > -1) {
        next();
      } else {
        next({ path: "/myExams" });
      }
    }
  }
});
